module.exports = __webpack_public_path__ + "static/media/file10.e7bf119c.jpg";